module.exports = __webpack_public_path__ + "media/src/assets/Images/BBVA-65c4ef76c0a53c0307090b13aa52ca35.svg";